module.exports = __webpack_public_path__ + "static/img/3575_phase_function_Paper_PointsHejduk_Prediction.5ab688b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/3575_phase_function_Paper_PointsHejduk_Prediction.png
// module id = 0Imq
// module chunks = 0